import {Component, OnInit} from '@angular/core';
import {PromotionDiscountTypeModel} from '../../../models/promotion-discount-type.model';
import {PromotionDiscountTypeService} from '../../../services/promotion/promotion-discount-type.service';

@Component({
  selector: 'kv-promo-discount-type',
  template: `
    <app-kontable
      id="dt_brand"
      title="{{ 'promotion.discountTypes' | translate }}"
      [columns]="['id', 'code', 'description']"
      [titles]="['#', 'promotion.code', 'promotion.description']"
      [source]="discountTypes"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-discount-type-detail
      *ngIf="show"
      [titlePage]="titlePage"
      [discountType]="addEditDiscountType"
      (hide)="toggleShow()"
      (saveDiscountType)="saveDiscountType($event)">
    </kv-promo-discount-type-detail>
  `
})
export class DiscountTypeComponent implements OnInit {

  addEditDiscountType;
  titlePage;
  show = false;
  discountTypes: PromotionDiscountTypeModel[];

  constructor(private svcDiscountService: PromotionDiscountTypeService) {
    this.svcDiscountService.list().subscribe((res) => {
      this.discountTypes = res.data;
    });
  }

  ngOnInit(): void {}

  delete(item) {
    this.svcDiscountService.delete(item.id).subscribe(() => {
      this.reloadList();
    })
  }

  showEdit(item) {
    this.titlePage = 'promotion.editDiscountType';
    this.addEditDiscountType = item;
    this.toggleShow()
  }

  showAdd() {
    this.titlePage = 'promotion.addDiscountType';
    this.addEditDiscountType = {code: '', description: ''};
    this.toggleShow()
  }

  saveDiscountType(item) {
    if (!item.id) {
      /*Creazione nuovo discount type*/
      this.svcDiscountService.create({
        code: item.code,
        description: item.description
      }).subscribe(() => {
        this.titlePage = '';
        this.addEditDiscountType = null;
        this.toggleShow();
        this.reloadList();
      });
    }else {
      /*Modifica discount type esistente*/
      this.svcDiscountService.update({
        id: item.id,
        code: item.code,
        description: item.description
      }).subscribe(() => {
        this.titlePage = '';
        this.addEditDiscountType = null;
        this.toggleShow();
        this.reloadList();
      });
    }
  }

  toggleShow() {
    this.show = !this.show;
  }

  reloadList() {
    this.discountTypes = [];
    this.svcDiscountService.list(0, 999999).subscribe( res => {
      this.discountTypes = res.data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/discount-type/discount-type.component.ts